import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { apiClient } from '../lib/api';
import GlassCard from '../components/GlassCard';
import GlassButton from '../components/GlassButton';

export default function AuthRegisterPage() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    first_name: '',
    last_name: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const response = await apiClient.register(formData);
      if (response.data) {
        navigate('/auth/login');
      } else {
        setError(response.error || 'Registration failed');
      }
    } catch (err) {
      setError('Neural registry unavailable.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl tabular-nums tracking-tighter font-bold text-text-primary mb-2">Establish Protocol</h1>
          <p className="text-text-secondary text-sm">Join the next-generation trading elite</p>
        </div>

        <GlassCard variant="elevated" className="p-8">
          <form onSubmit={handleRegister} className="space-y-6">
            {error && (
              <div className="p-3 bg-brand-plum/10 border border-brand-plum/20 rounded-xl text-brand-plum-light text-xs font-medium text-center">
                {error}
              </div>
            )}

            <div className="grid grid-cols-2 gap-4">
               <div className="space-y-2">
                <label className="text-xs font-bold uppercase tracking-widest text-text-secondary">First Name</label>
                <input
                  type="text"
                  value={formData.first_name}
                  onChange={(e) => setFormData({...formData, first_name: e.target.value})}
                  className="w-full bg-bg-secondary/50 border border-border-primary rounded-xl px-4 py-3 text-text-primary focus:outline-none focus:ring-2 focus:ring-brand-teal/50 transition-all backdrop-blur-md"
                  required
                />
              </div>
              <div className="space-y-2">
                <label className="text-xs font-bold uppercase tracking-widest text-text-secondary">Last Name</label>
                <input
                  type="text"
                  value={formData.last_name}
                  onChange={(e) => setFormData({...formData, last_name: e.target.value})}
                  className="w-full bg-bg-secondary/50 border border-border-primary rounded-xl px-4 py-3 text-text-primary focus:outline-none focus:ring-2 focus:ring-brand-teal/50 transition-all backdrop-blur-md"
                  required
                />
              </div>
            </div>

            <div className="space-y-2">
              <label className="text-xs font-bold uppercase tracking-widest text-text-secondary">Command Identity (Email)</label>
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full bg-bg-secondary/50 border border-border-primary rounded-xl px-4 py-3 text-text-primary focus:outline-none focus:ring-2 focus:ring-brand-teal/50 transition-all backdrop-blur-md"
                placeholder="operative@richguru.ai"
                required
              />
            </div>

            <div className="space-y-2">
              <label className="text-xs font-bold uppercase tracking-widest text-text-secondary">Access Key (Password)</label>
              <input
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({...formData, password: e.target.value})}
                className="w-full bg-bg-secondary/50 border border-border-primary rounded-xl px-4 py-3 text-text-primary focus:outline-none focus:ring-2 focus:ring-brand-teal/50 transition-all backdrop-blur-md"
                placeholder="Minimum 8 characters"
                minLength={8}
                required
              />
            </div>

            <div className="pt-2">
              <GlassButton
                type="submit"
                variant="primary"
                size="lg"
                glowEffect
                className="w-full font-bold"
                disabled={isLoading}
              >
                {isLoading ? 'Registry Syncing...' : 'Establish Identity'}
              </GlassButton>
            </div>
          </form>

          <div className="mt-8 pt-6 border-t border-white/5 text-center">
            <p className="text-text-muted text-xs">
              Already registered? {' '}
              <Link to="/auth/login" className="text-brand-teal-light font-bold hover:underline">
                Unlock Terminal
              </Link>
            </p>
          </div>
        </GlassCard>
      </div>
    </div>
  );
}
